export const TOKENS = Object.freeze({
  '#': {pattern: /[0-9]/},
  '@': {pattern: /[a-zA-Z]/},
  '*': {pattern: /[a-zA-Z0-9]/},
  A: {pattern: /[a-zA-Z]/, transform: (chr) => chr.toUpperCase()},
});
